import { useRecoilValue } from 'recoil';
import { Permissions } from './enum';
import { effectivePermissionsState } from '@/store/permissions';
import { hasPermission } from '@/utils/session-permissions';

interface PermissionCheckProps {
  userPermission: Permissions;
  lineOfBusinessId?: string;
  children: any;
}

const PermissionCheck: React.FC<PermissionCheckProps> = ({
  userPermission,
  lineOfBusinessId,
  children,
}) => {
  const permissions = useRecoilValue(effectivePermissionsState);
  return hasPermission(permissions, userPermission, lineOfBusinessId) ? (
    <>{children}</>
  ) : null;
};

export { PermissionCheck };
